const endpoint = (propertyId, orderId) => `/api/${propertyId}/orders/${orderId}/refund`;

export default ['api', function (api) {
    return {
        save: (order, refund) => {
            return api.post(endpoint(api.property(), order.id), refund).then(response => response.data);
        },
        getHistory: order => {
            return api.get(endpoint(api.property(), order.id)).then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/services/refund.service.js